import React, { useState } from 'react';
import {
  Container, Modal,
} from 'react-bootstrap';
import Checkbox from 'components/DesignSystem/Checkbox';
import Searcher from 'components/DesignSystem/Searcher';
import { SpacialSubdivisionOption } from 'helper/flux/automatic';
import { onTextChange } from 'helper/controlledField';
import removeAccents from 'helper/removeAccents';

import './index.scss';
import buildSets from 'helper/buildSets';

export default function SuboptionsModal({
  suboptions,
  show,
  onHide,
  onSave,
}: {
  suboptions: SpacialSubdivisionOption[],
  show: boolean,
  onHide: () => void,
  onSave: (maybeValue: SpacialSubdivisionOption | undefined) => void,
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const formattedSearchTerm = removeAccents(searchTerm).toLowerCase();
  const filteredSuboptions: SpacialSubdivisionOption[] = suboptions
    .filter(({ label }) => (
      removeAccents(label).toLowerCase().includes(formattedSearchTerm)
    ));
  const suboptionRows = buildSets(filteredSuboptions, 5);

  const toggleValue = (label: string, value: number) => {
    onSave({ label, value });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      onClose={onHide}
      dialogClassName="modal-dialog-scrollable modal-lg"
    >
      <Modal.Header closeButton>
        <Searcher
          className="suboptions-search-bar"
          value={searchTerm}
          onChange={onTextChange(setSearchTerm)}
          setSearchQuery={setSearchTerm}
          placeholder="Pesquisar"
        />
      </Modal.Header>
      <Modal.Body>
        <Container className="p-4">
          {suboptionRows.map((row) => (
            <div className="d-flex flex-wrap" key={row.map(({ label }) => label).join('-')}>
              {row.map(({ label, value }) => (
                <Checkbox
                  id={`filter-selection-suboptions-modal-checkbox-${label}`}
                  onChange={() => toggleValue(label, value)}
                  label={label}
                  className="filter-selection-suboptions-modal-checkbox"
                  key={`filter-selection-suboptions-modal-checkbox-${label}`}
                />
              ))}
            </div>
          ))}
        </Container>
      </Modal.Body>
    </Modal>
  );
}
